import { Component, OnInit, Input } from '@angular/core';



declare var google: any;

@Component({
  selector: 'app-charts',
  templateUrl: './charts.component.html',
  styleUrls: ['./charts.component.scss']
})
export class ChartsComponent implements OnInit {

  @Input() chartOpts: any;
  @Input() chartData: any;
  @Input() chartContainer: any;

  constructor() { }

  ngOnInit() {

    google.charts.load('current', { packages: ['corechart'] });
    var self = this;
    google.charts.setOnLoadCallback(function () {
      self.drawChart();
    });
  }

  drawChart() {

    if (this.chartOpts.chartType == 'ColumnChart') {
      this.buildColumn();
    } else if (this.chartOpts.chartType == "PieChart") {
      this.buildPie();
    }
    // this.chartOpts.containerId = this.chartContainer;
    // var wrapper = new google.visualization.ChartWrapper
    (this.chartOpts);
    // wrapper.draw();

  }


  buildColumn() {
    var data = google.visualization.arrayToDataTable(this.chartData);

    var chart = new google.visualization.ColumnChart
      (document.getElementById(this.chartContainer));
    chart.draw(data, this.chartOpts);

  }

  buildPie() {
    var data = google.visualization.arrayToDataTable(this.chartData);

    var chart = new google.visualization.PieChart
      (document.getElementById(this.chartContainer));
    chart.draw(data, this.chartOpts);
  }

  onReady() {
  }

  onError(e) {
  }

  onSelect(e) {
  }

}
